import { useState } from 'react';
import { Form, Input, Button, Card, Typography, Layout, Alert, Space } from 'antd';
import { UserOutlined, LockOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useAuth } from '../../stores/AuthContext';

const { Title } = Typography;
const { Content } = Layout;

export default function LoginPage() {
  const { login, requires2Fa } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [form] = Form.useForm();

  const onFinish = async (values: { userName: string; password: string; totpCode?: string }) => {
    setLoading(true);
    setError(null);
    try {
      await login(values);
    } catch (err: unknown) {
      const axiosError = err as { response?: { data?: { error?: string } } };
      setError(axiosError.response?.data?.error || 'Помилка входу. Спробуйте ще раз.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Card style={{ width: 400, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <div style={{ textAlign: 'center' }}>
              <Title level={3} style={{ margin: 0 }}>MedDevice ERP</Title>
              <Typography.Text type="secondary">Система управління медичними виробами</Typography.Text>
            </div>

            {error && <Alert message={error} type="error" showIcon closable onClose={() => setError(null)} />}

            <Form form={form} onFinish={onFinish} layout="vertical" size="large">
              <Form.Item
                name="userName"
                rules={[{ required: true, message: "Введіть ім'я користувача" }]}
              >
                <Input prefix={<UserOutlined />} placeholder="Ім'я користувача" />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Введіть пароль' }]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="Пароль" />
              </Form.Item>

              {requires2Fa && (
                <Form.Item
                  name="totpCode"
                  rules={[{ required: true, message: 'Введіть код 2FA' }]}
                >
                  <Input
                    prefix={<SafetyCertificateOutlined />}
                    placeholder="Код з Google Authenticator"
                    maxLength={6}
                  />
                </Form.Item>
              )}

              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading} block>
                  Увійти
                </Button>
              </Form.Item>
            </Form>
          </Space>
        </Card>
      </Content>
    </Layout>
  );
}
